import Controller from "./paymentMethods.controller";
import template from "./paymentMethods.html";

const paymentMethods = {
  template,
  controller: Controller,
};

export default paymentMethods;



// WEBPACK FOOTER //
// ./src/pages/paymentMethods/paymentMethods.component.js